import { render, staticRenderFns } from "./quilleditor.vue?vue&type=template&id=32764636&scoped=true&"
import script from "./quilleditor.vue?vue&type=script&lang=js&"
export * from "./quilleditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32764636",
  null
  
)

export default component.exports